
<script>
import {Pie} from 'vue-chartjs'

export default {
    extends: Pie,
    props: {
        options: {
            type: Object,
            default: () => ({ responsive: true, maintainAspectRatio: false })
        },
        labelSold: {
            Type: String,
            default: 'Sold'
        },
        labelPending: {
            Type: String,
            default: 'Pending'
        },
        labelAvailable: {
            Type: String,
            default: 'Available'
        },
        backgroundColorSold: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--gaugeThree')
        },
        backgroundColorPending: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--gaugeTwo')
        },
        backgroundColorAvailable: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--chartColorDefault')
        },
        width: {
            Type: Number,
            default: 200
        },
        height: {
            Type: Number,
            default: 200
        },
        amountSold: Number,
        amountPending: Number,
        amountAvailable: Number,
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            this.renderChart({
                    labels: [this.labelSold, this.labelPending, this.labelAvailable],
                    datasets: [{
                        backgroundColor: [this.backgroundColorSold, this.backgroundColorPending, this.backgroundColorAvailable],
                        data: [this.amountSold, this.amountPending, this.amountAvailable]
                    }]
                },
                this.options
            );
        }
    },
    watch: {
        amountSold() {
            this.render();
        },
        amountPending() {
            this.render();
        },
        amountAvailable() {
            this.render();
        }
    }
};
</script>
